// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-modal-info {
  height: 100vh;
  position: relative;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
  background-color: var(--background-color);
}

.slide-col {
  top: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  overflow: auto;
}

.option-group-col {
  flex-grow: 1;
  overflow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  padding: 15px 20px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-img {
  position: absolute;
  top: 30px;
  left: 30px;
}

.image-wrapper {
  background: black url('modal-info.png') no-repeat center center/100% 100%;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  position: relative;
}
.image-wrapper .back_icon {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 3;
}

.main-img {
  height: 300px;
  transition: transform 0.3s ease;
  margin: 0 2px 0px;
}
.main-img.not-selected {
  opacity: 0.4;
}
.main-img.selected-image {
  opacity: 1;
}
.main-img.rotate-right-pizza {
  transform: rotate(180deg);
}

.default-img {
  height: 200px;
}

.info {
  padding: 20px;
}
.info .title {
  text-align: center;
  text-transform: uppercase;
  font-size: 25px;
  line-height: var(--modal-info-title-line-height);
  margin-bottom: 6px;
  padding-top: 10px;
  color: var(--ion-color-primary);
}
.info .desc {
  text-align: center;
  font-size: var(--modal-info-desc-font-size);
  font-family: AppFont, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: #1A1A18;
}

.menge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 20px 20px;
}
.menge h5 {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  text-transform: uppercase;
}

ion-button {
  position: relative;
}
ion-button .buuton-text {
  font-size: var(--modal-info-button-font-size);
  color: var(--modal-info-button-text-color);
  margin-right: 10px;
}
ion-button .button-price {
  font-size: var(--modal-info-button-font-size);
  color: var(--modal-info-button-text-color);
}
ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}

ion-toolbar {
  height: 60px;
  display: flex;
  align-items: center;
  --background: var(--background-color);
}
ion-toolbar ion-title {
  font-weight: 100;
  padding-inline: unset !important;
  font-size: 16px;
  text-align: left;
  margin-left: 40px;
  font-family: AppFontBold, sans-serif;
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  padding: 8px;
  font-size: 15px;
}

.option-group-description {
  line-height: 95%;
  padding: 20px 25px;
  color: var(--ion-color-black);
  font-size: 20px;
  text-align: left;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  background: white;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  width: 100% !important;
}

ion-page {
  background: transparent;
}

.slider-select-half {
  height: 100%;
  width: 100%;
}

.separator {
  height: 14px;
  width: 100%;
  background: url('separator_doted.svg') no-repeat center center/100% 100%;
}
@media (min-width: 991px) {
  .separator {
    background: url('separator_doted.svg') no-repeat center center/100% 130%;
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator {
    height: 11px;
  }
}

.allergens {
  padding: 0px 20px;
  width: 100%;
}
.allergens app-accordion-list {
  width: 100%;
}

.padding-block {
  padding: 0px 20px;
}

.vertical-line {
  content: " ";
  width: 1px;
  height: 20px;
  color: white;
  background: white;
  margin-right: 10px;
}

.add-background {
  background: black url('background.png') no-repeat center center/100% 100% !important;
  background-size: cover;
}

.button-footer-block {
  background: white;
  margin: 0px !important;
  padding: 15px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
}

.article_section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.article_section .header_section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0px 20px;
}
.article_section .header_section .header_section_left {
  display: flex;
  align-items: center;
}
.article_section .header_section .header_section_left ion-icon {
  margin-right: 10px;
}
.article_section .header_section .header_section_right {
  cursor: pointer;
}
.article_section .header_section .header_section_right p {
  padding: 5px 15px;
  border: 1px solid black;
  border-radius: 50px;
  font-family: AppFontBold, sans-serif;
  color: black;
  text-transform: uppercase;
  font-size: 12px;
}

.footer_button {
  position: fixed;
  bottom: 0px;
  right: 0px;
  width: 100%;
  left: 0px;
  padding: 10px;
  z-index: 1;
  background-color: #fff;
}
.footer_button ion-button {
  width: 100%;
}

.overview-article {
  height: 100%;
  width: 100%;
  overflow: hidden auto;
  padding-bottom: 80px;
}

.wrapper_group {
  padding: 20px;
}
.wrapper_group .title_group {
  text-align: center;
}
.wrapper_group .wrapper_item {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
}
.wrapper_group .wrapper_item .item {
  margin: 5px;
  width: 22%;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  text-align: center;
}
.wrapper_group .wrapper_item .item.selected {
  border: 1px solid var(--ion-color-primary);
  border-radius: 10px;
}
.wrapper_group .wrapper_item .item ion-img {
  width: 45px;
  height: 45px;
}
.wrapper_group .wrapper_item .item h5 {
  font-size: 12px;
}

.articles_wrapper {
  padding: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.articles_wrapper h5 {
  padding: 0px 10px;
  font-size: 14px;
  color: rgb(196, 196, 196);
}

.padding-top {
  padding-top: 20px;
}

.title_group_first {
  text-align: center;
  padding: 20px 10px 10px;
}

.toolbar-items {
  padding: 5px;
}
.toolbar-items app-toolbar-venue-info {
  width: 95%;
}

.wrapper_toolbar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
}
.wrapper_toolbar ion-icon {
  cursor: pointer;
}
.wrapper_toolbar .info-section {
  width: 60%;
  text-align: center;
}
.wrapper_toolbar .info-section .section-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.wrapper_toolbar .info-section .section-info .step-indicator .step-text {
  font-family: AppFontBold, sans-serif;
  font-size: 12px;
  color: #dc143c;
  text-transform: uppercase;
  background: rgba(220, 20, 60, 0.1);
  padding: 4px 12px;
  border-radius: 12px;
  border: 1px solid #dc143c;
  white-space: nowrap;
}
.wrapper_toolbar .info-section .section-info .name h3 {
  margin: 0;
  font-size: 16px;
  color: black;
  font-family: AppFontBold, sans-serif;
}

.options-wrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.delete-option {
  position: absolute;
  bottom: 15px;
  right: 15px;
  z-index: 99;
  background: var(--ion-color-primary);
  border-top-left-radius: 15px;
  text-align: center;
  padding: 7px;
  border: 2px dotted white;
  width: 80px;
  height: 80px;
  min-height: 80px;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.delete-option p {
  font-size: 13px;
  font-family: "AppFontBold";
  text-transform: uppercase;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info-half-pizza/modal-info-half-pizza.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kBAAA;AADF;;AAIA;EACE,sBAAA;EACA,uBAAA;EACA,yCAAA;AADF;;AAIA;EACE,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;AADF;;AAMA;EACE,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,YAAA;EACA,cAAA;AAHF;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAHF;;AAKA;EACE,yEAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAFF;AAGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AADJ;;AAIA;EACE,aAAA;EACA,+BAAA;EAOA,iBAAA;AAPF;AACE;EACE,YAAA;AACJ;AACE;EACE,UAAA;AACJ;AAKE;EACE,yBAAA;AAHJ;;AAMA;EACE,aAAA;AAHF;;AAMA;EAEE,aAAA;AAJF;AAKE;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gDAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;AAHJ;AAME;EACE,kBAAA;EACA,2CAAA;EACA,gCAAA;EACA,+CAAA;EACA,oBAAA;EACA,cAAA;AAJJ;;AASA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EAMA,sBAAA;AAXF;AAME;EACE,oCAAA;EACA,eAAA;EACA,yBAAA;AAJJ;;AAUA;EACE,kBAAA;AAPF;AASE;EACE,6CAAA;EACA,0CAAA;EACA,kBAAA;AAPJ;AAUE;EACE,6CAAA;EACA,0CAAA;AARJ;AAWE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AATJ;;AAaA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;AAVF;AAWE;EACE,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AATJ;AAWE;EACE,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AATJ;AAYE;EACE,YAAA;EACA,eAAA;AAVJ;;AAaA;EACE,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,iBAAA;AAVF;;AAYA;EACE,sBAAA;EACA,uBAAA;AATF;;AAYA;EACE,sBAAA;AATF;;AAWA;EACE,uBAAA;AARF;;AAUA;EACE,YAAA;EACA,WAAA;AAPF;;AASA;EACC,YAAA;EACA,WAAA;EACA,wEAAA;AAND;ACtLE;EDyLF;IAKI,wEAAA;EAJF;AACF;AAIE;EANF;IAOG,YAAA;EADD;AACF;;AAIA;EACE,iBAAA;EACA,WAAA;AADF;AAEE;EACE,WAAA;AAAJ;;AAGA;EACE,iBAAA;AAAF;;AAEA;EACE,YAAA;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AACJ;;AACA;EACE,oFAAA;EACA,sBAAA;AAEF;;AAAA;EACE,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAGF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAIF;AAHE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AAKJ;AAJI;EACE,aAAA;EACA,mBAAA;AAMN;AALM;EACE,kBAAA;AAOR;AAJI;EACE,eAAA;AAMN;AALM;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;AAOR;;AAFA;EACE,eAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,sBAAA;AAKF;AAJE;EACE,WAAA;AAMJ;;AAHA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;AAMF;;AAJA;EACE,aAAA;AAOF;AANE;EACE,kBAAA;AAQJ;AANE;EACE,aAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;AAQJ;AAPI;EACE,WAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AASN;AARM;EACE,0CAAA;EACA,mBAAA;AAUR;AARM;EACE,WAAA;EACA,YAAA;AAUR;AARM;EACE,eAAA;AAUR;;AALA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAQF;AAPE;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;AASJ;;AANA;EACE,iBAAA;AASF;;AAPA;EACE,kBAAA;EACA,uBAAA;AAUF;;AARA;EACE,YAAA;AAWF;AAVE;EACE,UAAA;AAYJ;;AATA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAYF;AAVE;EACE,eAAA;AAYJ;AATE;EACE,UAAA;EACA,kBAAA;AAWJ;AATI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAWN;AARQ;EACE,oCAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAUV;AALQ;EACE,SAAA;EACA,eAAA;EACA,YAAA;EACA,oCAAA;AAOV;;AAAA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAGF;;AAAA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAGF;AAFE;EACE,eAAA;EAEA,0BAAA;EACA,yBAAA;EACA,YAAA;AAGJ","sourcesContent":["@import \"../../../theme/mixins\";\n\napp-modal-info {\n  height: 100vh;\n  position: relative;\n}\n\nion-slides {\n  width: 100% !important;\n  height: 100% !important;\n  background-color: var(--background-color);\n}\n\n.slide-col {\n  top: 0;\n  bottom: 0;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  background-size: 100% 30vh !important;\n  overflow: auto;\n\n  // padding: 23px;\n}\n\n.option-group-col {\n  flex-grow: 1;\n  overflow: auto;\n  flex-shrink: 1;\n  flex-basis: auto;\n  padding: 15px 20px;\n}\n\n.grow {\n  flex-grow: 1;\n  overflow: auto;\n}\n\n.back-img {\n  position: absolute;\n  top: 30px;\n  left: 30px;\n}\n.image-wrapper {\n  background: black url('../../../assets/losteria/modal-info.png') no-repeat center center / 100% 100%;\n  display: flex;\n  justify-content: center;\n  flex-wrap: nowrap;\n  position: relative;\n  .back_icon {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    z-index: 3;\n  }\n}\n.main-img {\n  height: 300px;\n  transition: transform 0.3s ease;\n  &.not-selected {\n    opacity: 0.4;\n  }\n  &.selected-image {\n    opacity: 1;\n  }\n  margin: 0 2px 0px;\n  &.first {\n    // rotate: 180deg;\n  }\n  &.rotate-right-pizza {\n    transform: rotate(180deg);\n  }\n}\n.default-img {\n  height: 200px;\n\n}\n.info {\n\n  padding: 20px;\n  .title {\n    text-align: center;\n    text-transform: uppercase;\n    font-size: 25px;\n    line-height: var(--modal-info-title-line-height);\n    margin-bottom: 6px;\n    padding-top: 10px;\n    color: var(--ion-color-primary)    ;\n  }\n\n  .desc {\n    text-align: center;\n    font-size: var(--modal-info-desc-font-size);\n    font-family: AppFont ,sans-serif;\n    line-height: var(--modal-info-desc-line-height);\n    padding-bottom: 10px;\n    color: #1A1A18\n    ;\n  }\n}\n\n.menge {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  h5 {\n    font-family: AppFontBold,sans-serif;\n    font-size: 18px;\n    text-transform: uppercase;\n  }\n  margin: 20px 20px 20px;\n}\n\n\nion-button {\n  position: relative;\n  \n  .buuton-text {\n    font-size: var(--modal-info-button-font-size);\n    color: var(--modal-info-button-text-color);\n    margin-right: 10px;\n  }\n\n  .button-price {\n    font-size: var(--modal-info-button-font-size);\n    color: var(--modal-info-button-text-color);\n  }\n\n  .button-icon {\n    position: absolute;\n    right: 5px;\n    height: 34px;\n    width: 34px;\n  }\n}\n\nion-toolbar {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  --background: var(--background-color);\n  ion-title {\n    font-weight: 100;\n    padding-inline: unset !important;\n    font-size: 16px;\n    text-align: left;\n    margin-left: 40px;\n    font-family: AppFontBold ,sans-serif;\n  }\n  ion-button {\n    --background: transparent;\n    --background-activated: transparent;\n    --background-focused: transparent;\n    --background-hover: transparent;\n  }\n\n  ion-icon {\n    padding: 8px;\n    font-size: 15px;\n  }\n}\n.option-group-description {\n  line-height: 95%;\n  padding: 20px 25px;\n  color: var(--ion-color-black);\n  font-size: 20px;\n  text-align: left;  \n  font-family: AppFontBold, sans-serif;\n  text-transform: uppercase;\n  background: white;\n}\nswiper-container {\n  width: 100% !important;\n  height: 100% !important;\n}\n\nswiper-slide {\n  width: 100% !important;\n}\nion-page {\n  background: transparent;\n}\n.slider-select-half {\n  height: 100%;\n  width: 100%;\n}\n.separator {\n\theight: 14px;\n\twidth: 100%;\n\tbackground: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n\t@include desktop {\n    background: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 130%;\n\t\t@media (max-height: 750px) {\n\t\t\theight: 11px;\n\t\t}\n\t}\n}\n.allergens {\n  padding:0px 20px;\n  width: 100%;\n  app-accordion-list {\n    width: 100%;\n  }\n}\n.padding-block {\n  padding: 0px 20px;\n}\n.vertical-line {\n  content: ' ';\n    width: 1px;\n    height: 20px;\n    color: white;\n    background: white;\n    margin-right: 10px;\n}\n.add-background {\n  background: black url(../../../assets/background/background.png)  no-repeat center center / 100% 100% !important;\n  background-size: cover;\n}\n.button-footer-block {\n  background: white;\n  margin: 0px !important;\n  padding: 15px;\n  position: fixed;\n  bottom: 0px;\n  left: 0px;\n  width: 100%;\n  z-index: 999;\n}\n.article_section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  .header_section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding:0px 20px;\n    .header_section_left {\n      display: flex;\n      align-items: center;\n      ion-icon {\n        margin-right: 10px;\n      }\n    }\n    .header_section_right {\n      cursor: pointer;\n      p {\n        padding:5px 15px;\n        border: 1px solid black;\n        border-radius: 50px;\n        font-family: AppFontBold, sans-serif;\n        color: black;\n        text-transform: uppercase;\n        font-size: 12px;\n      }\n    }\n  }\n}\n.footer_button {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  width: 100%;\n  left: 0px;\n  padding: 10px;\n  z-index: 1;\n  background-color: #fff;\n  ion-button {\n    width: 100%;\n  }\n}\n.overview-article {\n  height: 100%;\n  width: 100%;\n  overflow: hidden auto;\n  padding-bottom: 80px;\n}\n.wrapper_group {\n  padding: 20px;\n  .title_group {\n    text-align: center;\n  }\n  .wrapper_item {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    justify-content: center;\n    .item {\n      margin: 5px;\n      width: 22%;\n      padding-bottom: 10px;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-end;\n      align-items: center;\n      text-align: center;\n      &.selected {\n        border: 1px solid var(--ion-color-primary);\n        border-radius: 10px;\n      }\n      ion-img {\n        width: 45px;\n        height: 45px;\n      }\n      h5 {\n        font-size: 12px;\n      }\n    }\n  }\n}\n.articles_wrapper {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  h5 {\n    padding: 0px 10px;\n    font-size: 14px;\n    color: rgb(196, 196, 196);\n  }\n}\n.padding-top {\n  padding-top: 20px;\n}\n.title_group_first {\n  text-align: center;\n  padding: 20px 10px 10px;\n}\n.toolbar-items {\n  padding: 5px ;\n  app-toolbar-venue-info {\n    width: 95%;\n  }\n}\n.wrapper_toolbar {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 40px;\n\n  ion-icon {\n    cursor: pointer;\n  }\n\n  .info-section {\n    width: 60%;\n    text-align: center;\n\n    .section-info {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: center;\n      gap: 8px;\n\n      .step-indicator {\n        .step-text {\n          font-family: AppFontBold, sans-serif;\n          font-size: 12px;\n          color: #dc143c;\n          text-transform: uppercase;\n          background: rgba(220, 20, 60, 0.1);\n          padding: 4px 12px;\n          border-radius: 12px;\n          border: 1px solid #dc143c;\n          white-space: nowrap;\n        }\n      }\n\n      .name {\n        h3 {\n          margin: 0;\n          font-size: 16px;\n          color: black;\n          font-family: AppFontBold, sans-serif;\n        }\n      }\n    }\n  }\n}\n\n.options-wrapper {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.delete-option {\n  position: absolute;\n  bottom: 15px;\n  right: 15px;\n  z-index: 99;\n  background: var(--ion-color-primary);\n  border-top-left-radius: 15px;\n  text-align: center;\n  padding: 7px;\n  border: 2px dotted white;\n  width: 80px;\n  height: 80px;\n  min-height: 80px;\n  min-width: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  p {\n    font-size: 13px;\n\n    font-family: 'AppFontBold';\n    text-transform: uppercase;\n    color: white;\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
